module.exports = __webpack_public_path__ + "static/webby_logo-a9be7ecc374c3650af4901b904862276.png";